/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable babel/camelcase */
import BiliAjax from '@bilibili/bjax'
import request from '@plat-components/utils2/_esm5/request'
import toast from '@bilibili/vanilla-toast'
import { getCookie } from '@plat-components/utils2/_esm5/cookie'
import { AbstractInterface, ReserveListData, UserInfo, Award, RankDataList } from '../types'
import { useMock, APIHost } from './config'
import login from './login'
import getQueryVariable from '@common/getQueryVariable';

export const http = new BiliAjax({})
const actApiPrefix = useMock ? `${location.protocol}/x/activity` : `${APIHost}/x/activity`
const csrf = getCookie('bili_jct')

const errHandler = (err: Error) => {
  const msg = err.message || '服务出现一点小问题，请稍后重试'
  toast.info(msg)
  return Promise.reject(msg)
}

export const getUserInfo = async () => {
  return http.user()
  // const res: UserInfo = await http.user()
  // if (!res) {
  //   return Promise.reject({} as UserInfo)
  // }
  // return Promise.resolve(res)
}

export const getAwardData = async (): Promise<Award> => {
  let mid; 
  try {
    mid = parseInt(getQueryVariable('mid'))
  } catch (err:any) {
    mid = ''
  }
  try {
    const res: AbstractInterface<Award> = await http.get(`${APIHost}/x/operational_activity/s13up/award`, {
      mid
    })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as Award)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  }
}

// 获取排行榜榜单
export const getRankList = async (rankID: number): Promise<any> => {
  try {
    const res: AbstractInterface<any> = await http
      .get(`${APIHost}/x/activity/rank_v3/result`, {
        rank_id: rankID,
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data as RankDataList)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  }
}

export const getSwiperList =async (): Promise<any> => {
  try {
    const res: AbstractInterface<any> = await http
      .get(`${APIHost}/x/activity/operation/list`, {
        source_id: '6500225e96e18806ee5bafa3'
      })
    if (res.code !== 0) throw new Error(res.message)
    return Promise.resolve(res.data)
  } catch (err:any) {
    errHandler(err)
    return Promise.reject(err.message)
  }
}

export default {
  getUserInfo,
  getAwardData,
  getRankList,
  getSwiperList,
}
